import Vue from 'vue';

const LAHI_CALCULATE_CTA_GTM = 'homeLoanCalc';
const LAHI_RE_CALCULATE_CTA_GTM = 'homeLoanReCalc';
const LAHI_CALCULATE_CTA_ERROR_GTM = 'homeLoanCalcError';

export const sendCalculationCtaGtm = ({ hasCalculation, actualCalculatorTab, data, backendInitData, technicalError }) => {
	let gtmData = {
		event: !hasCalculation ? LAHI_CALCULATE_CTA_GTM : LAHI_RE_CALCULATE_CTA_GTM,
		homeLoanGoal: actualCalculatorTab.tabTitle,
		homeLoanAmount: data.amount,
		homeLoanTerm: data.duration,
		technicalIssue: technicalError
	};
	if (backendInitData.csokMatters) {
		gtmData.homeLoanCSOK = data.csok;
	}
	if (backendInitData.loyaltyMatters && data.loyaltyDiscount) {
		gtmData.homeLoanBankTransferAmount = data.income;
	}
	if (backendInitData.childrenMatter) {
		gtmData.homeLoanChildren = data.children;
	}
	Vue.gtm.trackEvent(gtmData);
};

export const sendCalculationErrorGtm = () => {
	Vue.gtm.trackEvent({
		event: LAHI_CALCULATE_CTA_ERROR_GTM
	});
};
